(function () {
  if (customElements.get('minicart-upsell')) return;

  function escapeHtml(value) {
    return String(value).replace(/[&<>"']/g, function (char) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[char];
    });
  }

  function imageSrc(src) {
    if (!src) return '';
    return src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=240';
  }

  function formatMoney(cents, format) {
    var amount = (cents / 100).toFixed(2);
    var whole = String(Math.round(cents / 100));
    return (format || '${{amount}}')
      .replace(/\{\{\s*amount\s*\}\}/, amount)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, whole)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, amount.replace('.', ','));
  }

  class MinicartUpsell extends HTMLElement {
    connectedCallback() {
      if (this.dataset.bound !== 'true') {
        this.dataset.bound = 'true';
        this.addEventListener('click', this.onClick);
      }
      this.load();
    }

    onClick(event) {
      var button = event.target.closest('.minicart-upsell__add');
      if (!button || button.disabled) return;
      var id = button.getAttribute('data-variant');
      var root = event.currentTarget;
      button.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: Number(id), quantity: 1 })
      })
        .then(function (response) {
          if (!response.ok) throw new Error('add');
          return response.json();
        })
        .then(function (item) {
          document.dispatchEvent(new CustomEvent('cart:update', {
            bubbles: true,
            detail: { resource: item, sourceId: 'minicart-upsell', data: {} }
          }));
        })
        .catch(function () {
          button.disabled = false;
        });
      root.dataset.loaded = '';
    }

    load() {
      var productId = this.dataset.productId;
      var row = this.querySelector('[data-upsell-row]');
      if (!productId || !row || this.dataset.loading === 'true') return;
      if (row.children.length && this.dataset.loaded === 'true') return;

      this.dataset.loading = 'true';
      var inCart = (this.dataset.inCart || '').split(',');
      var format = this.dataset.moneyFormat || '${{amount}}';
      var element = this;

      fetch('/recommendations/products.json?product_id=' + productId + '&limit=8&intent=related')
        .then(function (response) {
          if (!response.ok) throw new Error('recommendations');
          return response.json();
        })
        .then(function (data) {
          var current = element.querySelector('[data-upsell-row]');
          if (!current) return;
          var products = (data.products || []).filter(function (product) {
            return inCart.indexOf(String(product.id)) === -1 && product.available && product.handle !== 'grounding-sheet';
          }).slice(0, 6);
          if (!products.length) return;
          current.innerHTML = products.map(function (product) {
            var variant = (product.variants || []).find(function (item) { return item.available; }) || product.variants[0];
            if (!variant) return '';
            var image = product.featured_image;
            var src = imageSrc(typeof image === 'string' ? image : (image && (image.src || image.url)) || '');
            var option = variant.title && variant.title !== 'Default Title' ? escapeHtml(variant.title) : '';
            var compare = variant.compare_at_price > variant.price
              ? '<s>' + formatMoney(variant.compare_at_price, format) + '</s>'
              : '';
            return (
              '<article class="minicart-upsell__card">' +
                '<div class="minicart-upsell__media">' +
                  (src ? '<img src="' + escapeHtml(src) + '" alt="" width="100" height="80">' : '') +
                '</div>' +
                '<div class="minicart-upsell__body">' +
                  '<div class="minicart-upsell__top">' +
                    '<div><p class="minicart-upsell__name">' + escapeHtml(product.title) + '</p>' +
                    (option ? '<p class="minicart-upsell__option">' + option + '</p>' : '') +
                    '</div>' +
                    '<div class="minicart-upsell__price"><span>' + formatMoney(variant.price, format) + '</span>' + compare + '</div>' +
                  '</div>' +
                  '<button type="button" class="minicart-upsell__add" data-variant="' + variant.id + '">Add to cart</button>' +
                '</div>' +
              '</article>'
            );
          }).join('');
          element.hidden = false;
          element.dataset.loaded = 'true';
        })
        .catch(function () {})
        .finally(function () {
          element.dataset.loading = '';
        });
    }
  }

  customElements.define('minicart-upsell', MinicartUpsell);

  document.addEventListener('cart:update', function () {
    setTimeout(function () {
      document.querySelectorAll('minicart-upsell').forEach(function (el) {
        var row = el.querySelector('[data-upsell-row]');
        if (row && !row.children.length) el.load();
      });
    }, 0);
  });
})();
